import { useEffect, useState } from 'react'
import { useCookieConsentContext } from './CookieConsentContext'

declare global {
  interface Window {
    fbq: any
  }
}

/**
 * This component handles cookie consent for Meta Pixels.
 */
const MetaConsentHandler = () => {
  const { ethycaInitialized, marketingConsent } = useCookieConsentContext()
  const [fbqInitialized, setFbqInitialized] = useState(false)

  const handleFbqInitialized = () => {
    setFbqInitialized(true)
  }

  useEffect(() => {
    if (!window.fbq) {
      window.addEventListener('fbq_initialized', handleFbqInitialized)
    }
    return () => {
      window.removeEventListener('fbq_initialized', handleFbqInitialized)
    }
  }, [])

  useEffect(() => {
    if (!ethycaInitialized || window.fbq === undefined) {
      return
    }
    if (marketingConsent) {
      window.fbq('consent', 'grant')
    } else {
      window.fbq('consent', 'revoke')
    }
  }, [ethycaInitialized, marketingConsent, fbqInitialized])
  return null
}

export default MetaConsentHandler
